import { Tag as TagPrimitive, } from "@digdir/designsystemet-react";
import cn from "clsx";
import * as React from "react";
const Tag = React.forwardRef(({ className, hero, children, style, ...props }, ref) => {
    return (React.createElement(TagPrimitive, { className: cn("in-tag", hero && "in-tag-hero", className), ref: ref, ...props, style: { ...style } }, children));
});
Tag.displayName = "Tag";
export { Tag };
//# sourceMappingURL=tag.js.map